/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

type PropsType = {
  handleShowModal: () => void,
  handleRemoveSponsor: () => void,
  getGlobalSponsors: () => void,
  isEmptySelectedItems: boolean,
  isEmptyList: boolean
};

const EventPageSponsorSearchbar = ({
  handleShowModal,
  handleRemoveSponsor,
  isEmptySelectedItems,
  getGlobalSponsors,
  isEmptyList
}: PropsType): React.Element<'div'> => {

  return (
    <div className="container-fluid search-bar">
      <div className="s-table">
        <div className="s-cell">
          <div className="navbar-form" style={{ float:'none', padding: '1rem 0' }} role="search">
            <div className="input-group event-search" style={{ width:'100%', display: 'none' }}>
              <input
                className="form-control"
                type="text"
                placeholder="search"
                autoComplete="off"
                disabled
              />
              <span className="input-group-btn" style={{ width:'30px' }}>
                <button className="btn btn-default btn-search" type="button">
                  <span className="icon icon-search" />
                </button>
              </span>
            </div>
          </div>
        </div>

        <div className="s-cell s-cell-buttons" style={{ width: '1%' }}>
          <ul className="nav">
            {!isEmptyList &&
              <li
                className={`actionBtn ${isEmptySelectedItems ? 'is-disabled' : ''}`}
                onClick={(): void => handleRemoveSponsor()}
              >
                <a href='#'><span>Remove</span></a>
              </li>
            }
            <li onClick={() => {
                getGlobalSponsors();
                handleShowModal(true);
              }}
            >
              <a href='#'><span>Add</span></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default EventPageSponsorSearchbar;
